const React = require('react')
const PropTypes = require('prop-types')

// page components which wrap marionette page controllers can use this
// component. the containr component must pass a props.getController method
// which accepts a callback, and calls back with a Controller class

class MarionetteControllerRegion extends React.Component {

    componentDidMount() {
        this.createController()
    }

    componentWillUnmount() {
        this.destroyController()
        this.destroyRegion()
    }

    createController() {
        this.props.getController((Controller, options = {}) => {
            if (! Controller) throw new Error('getController must return a Marionette Object.')
            const Marionette = require('lib/marionette')
            this.region = new Marionette.Region({
                el: this.el,
            })
            options.region = this.region
            options.context = this.context
            this.controller = new Controller(options)
        })
    }

    destroyController() {
        if (this.controller) this.controller.destroy()
    }

    destroyRegion() {
        if (this.region) {
            this.region.empty()
            this.region.destroy()
        }
    }

    render() {
        const { className, style } = this.props
        return (
            <div
                className={className}
                style={style}
                ref={(el) => { this.el = el }}
                />
        )
    }

}

MarionetteControllerRegion.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    getController: PropTypes.func.isRequired,
}

MarionetteControllerRegion.contextTypes = {
    page: PropTypes.object.isRequired,
}

module.exports = MarionetteControllerRegion
